import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-infobox',
  styleUrl: 'cms-infobox.scss',
  shadow: true,
})
export class CmsInfobox {
  private readonly icon = 'notificationInfo';

  /**
   * set the infobox headline h3
   */
  @Prop() headline = '';

  /**
   * set the infobox text
   */
  @Prop() content = '';

  render() {
    return (
      <Host>
        <div class={'infobox-inner'}>
          {this.headline ? (
            <div class='infobox-headline-wrapper'>
              <div class='svg-warning-wrapper'>
                <cms-badge
                  icon={this.icon}
                  iconSize='xl'
                  name={
                    <cms-headline
                      headlineTag='h3'
                      headlineText={this.headline}
                      style={{
                        '--cms-grid-padding': '0',
                        '--cms-spacing-top': '0',
                        '--cms-spacing-bottom': '0',
                        '--cms-headline-text-color':
                          'var(--cms-theme-inverted-text-color)',
                      }}
                      layout='full'
                      is-adaptive
                    >
                      {this.headline}
                    </cms-headline>
                  }
                  theme='secondary'
                  size='badge-md'
                />
              </div>
            </div>
          ) : null}

          <div
            class='infobox-text-wrapper'
            style={
              this.headline
                ? {
                    '--cms-theme-text-color':
                      'var(--cms-semanticColors-primary-textOnBackground)',
                    'margin-top': '-1rem',
                  }
                : {
                    '--cms-theme-text-color':
                      'var(--cms-semanticColors-primary-textOnBackground)',
                  }
            }
            innerHTML={this.content}
          />
        </div>
      </Host>
    );
  }
}
